<form [formGroup]="formGroup" autocomplete="off" (ngSubmit)="save(formGroup)">
  <h1 mat-dialog-title>{{ 'settings.form.title' | translate }}</h1>
  <mat-dialog-content>
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">visibility</mat-icon>
        </ng-template>
        <p>
          <mat-slide-toggle formControlName="showKeyboard"
            matTooltip="{{ 'settings.form.set.showKeyboard.tip' | translate }}">
            {{ 'settings.form.set.showKeyboard.label' | translate }}</mat-slide-toggle>
        </p>
        <p>
          <mat-slide-toggle formControlName="animatedStave"
            matTooltip="{{ 'settings.form.set.animatedStave.tip' | translate }}">
            {{ 'settings.form.set.animatedStave.label' | translate }}</mat-slide-toggle>
        </p>
        <p>
          <mat-slide-toggle formControlName="showAllNotes"
            matTooltip="{{ 'settings.form.set.showAllNotes.tip' | translate }}">
            {{ 'settings.form.set.showAllNotes.label' | translate }}</mat-slide-toggle>
        </p>
        <p>
          <mat-slide-toggle formControlName="allowDarkTheme"
            matTooltip="{{ 'settings.form.set.allowDarkTheme.tip' | translate }}">
            {{ 'settings.form.set.allowDarkTheme.label' | translate }}</mat-slide-toggle>
        </p>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">music_note</mat-icon>
        </ng-template>
        <p>
          <mat-form-field>
            <mat-label>{{ 'settings.form.set.generate.nbChords.label' | translate }}</mat-label>
            <input formControlName="generateNbChords" matInput
              matTooltip="{{ 'settings.form.set.generate.nbChords.tip' | translate }}">
          </mat-form-field>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.chordWidth.label' | translate }} </mat-label>
          <mat-slider thumbLabel min='2' max='6' formControlName="generateChordWidth"
            matTooltip="{{ 'settings.form.set.generate.chordWidth.tip' | translate }}"></mat-slider>
        </p>
        <p>
          <mat-form-field>
            <mat-label>{{ 'settings.form.set.generate.noteOctave.label' | translate }}</mat-label>
            <input formControlName="generateNoteOctave" matInput
              matTooltip="{{ 'settings.form.set.generate.noteOctave.tip' | translate }}">
          </mat-form-field>
        </p>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">speed</mat-icon>
        </ng-template>
        <p>
          <mat-form-field>
            <mat-label>{{ 'settings.form.set.generate.chordDuration.label' | translate }}</mat-label>
            <input formControlName="generateChordDuration" matInput
              matTooltip="{{ 'settings.form.set.generate.chordDuration.tip' | translate }}">
          </mat-form-field>
          <!-- <mat-form-field> TODO
            <mat-label>{{ 'settings.form.set.generate.chordDurationUnit.label' | translate }}</mat-label>
            <mat-select formControlName="generateChordDurationUnit" [compareWith]="compareItemsById"
              matTooltip="{{ 'settings.form.set.generate.chordDurationUnit.tip' | translate }}">
              <mat-option *ngFor="let chordDurationUnit of chordDurationUnits" value="{{ chordDurationUnit.id }}">
                {{ chordDurationUnit.name }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
        </p>
        <p>
          <mat-form-field>
            <mat-label>{{ 'settings.form.set.generate.tempoBpm.label' | translate }}</mat-label>
            <input formControlName="generateTempoBpm" matInput
              matTooltip="{{ 'settings.form.set.generate.tempoBpm.tip' | translate }}">
          </mat-form-field>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.timeSignature.label' | translate }}</mat-label>
        </p>
        <p>
          <mat-form-field>
            <mat-label>{{ 'settings.form.set.generate.timeSignatureNbOfTimeUnits.label' | translate }}</mat-label>
            <mat-select formControlName="generateTimeSignatureNumerator" [compareWith]="compareItemsById"
              matTooltip="{{ 'settings.form.set.generate.timeSignatureNbOfTimeUnits.tip' | translate }}">
              <mat-option *ngFor="let timeSignature of timeSignatures" value="{{ timeSignature.id }}">
                {{ timeSignature.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          /
          <mat-form-field>
            <mat-label>{{ 'settings.form.set.generate.timeSignatureTimeUnit.label' | translate }}</mat-label>
            <mat-select formControlName="generateTimeSignatureDenominator" [compareWith]="compareItemsById"
              matTooltip="{{ 'settings.form.set.generate.timeSignatureTimeUnit.tip' | translate }}">
              <mat-option *ngFor="let timeSignature of timeSignatures" value="{{ timeSignature.id }}">
                {{ timeSignature.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </p>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">tune</mat-icon>
        </ng-template>
        <p>
          <mat-label>{{ 'settings.form.set.generate.inpassingNote.label' | translate }} </mat-label>
          <mat-slider thumbLabel [displayWith]="formatAsPercentage" min="0" max="100" step="5" formControlName="generateInpassingNote"
            matTooltip="{{ 'settings.form.set.generate.inpassingNote.tip' | translate }}"></mat-slider>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.nbSemiTonesAsInpassingNotes.label' | translate }} </mat-label>
          <mat-slider thumbLabel min="2" max="10" step="1" formControlName="generateNbSemiTonesAsInpassingNotes"
            matTooltip="{{ 'settings.form.set.generate.nbSemiTonesAsInpassingNotes.tip' | translate }}"></mat-slider>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.nbSemiTonesAsNearNotes.label' | translate }} </mat-label>
          <mat-slider thumbLabel min="2" max="10" step="1" formControlName="generateNbSemiTonesAsNearNotes"
            matTooltip="{{ 'settings.form.set.generate.nbSemiTonesAsNearNotes.tip' | translate }}"></mat-slider>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.bonusMin.label' | translate }} </mat-label>
          <mat-slider thumbLabel min="0" max="5" step="1" formControlName="generateBonusMin"
            matTooltip="{{ 'settings.form.set.generate.bonusMin.tip' | translate }}"></mat-slider>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.bonusRandom.label' | translate }} </mat-label>
          <mat-slider thumbLabel [displayWith]="formatAsPercentage" min="0" max="100" step="10" formControlName="generateBonusRandom"
            matTooltip="{{ 'settings.form.set.generate.bonusRandom.tip' | translate }}"></mat-slider>
        </p>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">tune</mat-icon>
        </ng-template>
        <p>
          <mat-form-field>
            <mat-label>{{ 'settings.form.set.generate.tonality.label' | translate }}</mat-label>
            <mat-select formControlName="generateTonality" [compareWith]="compareItemsById"
              matTooltip="{{ 'settings.form.set.generate.tonality.tip' | translate }}">
              <mat-option *ngFor="let generateTonality of generateTonalities" value="{{ generateTonality.id }}">
                {{ generateTonality.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </p>
        <p>
          <mat-slide-toggle formControlName="generateOnlyMajorTonalities"
            matTooltip="{{ 'settings.form.set.generate.generateOnlyMajorTonalities.tip' | translate }}">
            {{ 'settings.form.set.generate.generateOnlyMajorTonalities.label' | translate }}</mat-slide-toggle>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.modulation.label' | translate }} </mat-label>
          <mat-slider thumbLabel [displayWith]="formatAsPercentage" min="0" max="100" step="5" formControlName="generateModulation"
            matTooltip="{{ 'settings.form.set.generate.modulation.tip' | translate }}"></mat-slider>
        </p>
        <p>
          <mat-slide-toggle formControlName="generateDoubleChord"
            matTooltip="{{ 'settings.form.set.generate.doubleChord.tip' | translate }}">
            {{ 'settings.form.set.generate.doubleChord.label' | translate }}</mat-slide-toggle>
        </p>
        <p>
          <mat-slide-toggle formControlName="generateReverseDissimilarChord"
            matTooltip="{{ 'settings.form.set.generate.reverseDissimilarChord.tip' | translate }}">
            {{ 'settings.form.set.generate.reverseDissimilarChord.label' | translate }}</mat-slide-toggle>
        </p>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">equalizer</mat-icon>
        </ng-template>
        <mat-label matTooltip="{{ 'settings.form.set.tracks.tip' | translate }}">{{ 'settings.form.set.tracks.label' | translate }} </mat-label>
        <p>
          <mat-slide-toggle formControlName="generateMelody"
            matTooltip="{{ 'settings.form.set.generate.melody.tip' | translate }}">
            {{ 'settings.form.set.generate.melody.label' | translate }}</mat-slide-toggle>
        </p>
        <p>
          <mat-slide-toggle formControlName="generateHarmony"
            matTooltip="{{ 'settings.form.set.generate.harmony.tip' | translate }}">
            {{ 'settings.form.set.generate.harmony.label' | translate }}</mat-slide-toggle>
        </p>
        <p>
          <mat-slide-toggle formControlName="generateDrums"
            matTooltip="{{ 'settings.form.set.generate.drums.tip' | translate }}">
            {{ 'settings.form.set.generate.drums.label' | translate }}</mat-slide-toggle>
        </p>
        <p>
          <mat-slide-toggle formControlName="generateBass"
            matTooltip="{{ 'settings.form.set.generate.bass.tip' | translate }}">
            {{ 'settings.form.set.generate.bass.label' | translate }}</mat-slide-toggle>
        </p>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">volume_up</mat-icon>
        </ng-template>
        <p>
          <mat-label matTooltip="{{ 'settings.form.set.velocity.tip' | translate }}">{{ 'settings.form.set.velocity.label' | translate }} </mat-label>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.velocity.melody.label' | translate }} </mat-label>
          <mat-slider thumbLabel [displayWith]="formatAsPercentage" min="0" max="100" step="5" formControlName="generateVelocityMelody"
          matTooltip="{{ 'settings.form.set.generate.velocity.melody.tip' | translate }}"></mat-slider>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.velocity.harmony.label' | translate }} </mat-label>
          <mat-slider thumbLabel [displayWith]="formatAsPercentage" min="0" max="100" step="5" formControlName="generateVelocityHarmony"
          matTooltip="{{ 'settings.form.set.generate.velocity.harmony.tip' | translate }}"></mat-slider>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.velocity.drums.label' | translate }} </mat-label>
          <mat-slider thumbLabel [displayWith]="formatAsPercentage" min="0" max="100" step="5" formControlName="generateVelocityDrums"
          matTooltip="{{ 'settings.form.set.generate.velocity.drums.tip' | translate }}"></mat-slider>
        </p>
        <p>
          <mat-label>{{ 'settings.form.set.generate.velocity.bass.label' | translate }} </mat-label>
          <mat-slider thumbLabel [displayWith]="formatAsPercentage" min="0" max="100" step="5" formControlName="generateVelocityBass"
           matTooltip="{{ 'settings.form.set.generate.velocity.bass.tip' | translate }}"></mat-slider>
        </p>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
  <mat-dialog-actions>
    <mat-toolbar>
      <button mat-flat-button type="button" (click)="close()">{{ 'settings.form.cancel' | translate }}</button>
      <span class="fill-remaining-space"></span>
      <button mat-flat-button color="primary" [disabled]="!formGroup.valid" type="submit">{{ 'settings.form.save' | translate }}</button>
    </mat-toolbar>
  </mat-dialog-actions>
</form>
